/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectChangesSettingsControllerFindContractBaselineQueryResponse, ProjectChangesSettingsControllerFindContractBaselinePathParams, ProjectChangesSettingsControllerFindContractBaselineQueryParams, ProjectChangesSettingsControllerFindContractBaseline400, ProjectChangesSettingsControllerFindContractBaseline401, ProjectChangesSettingsControllerFindContractBaseline403, ProjectChangesSettingsControllerFindContractBaseline404 } from "../../models/changeOrdersController/ProjectChangesSettingsControllerFindContractBaseline";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectChangesSettingsControllerFindContractBaseline } from "../../clients/change-ordersService/projectChangesSettingsControllerFindContractBaseline";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectChangesSettingsControllerFindContractBaselineQueryKey = (projectId: ProjectChangesSettingsControllerFindContractBaselinePathParams["projectId"], params: ProjectChangesSettingsControllerFindContractBaselineQueryParams = {}) => [{
  url: '/api/v1/project-changes-settings/:projectId/contract-baseline',
  params: {
    projectId: projectId
  }
}, ...(params ? [params] : [])] as const;
export type ProjectChangesSettingsControllerFindContractBaselineQueryKey = ReturnType<typeof projectChangesSettingsControllerFindContractBaselineQueryKey>;
export function projectChangesSettingsControllerFindContractBaselineQueryOptions(projectId: ProjectChangesSettingsControllerFindContractBaselinePathParams["projectId"], params?: ProjectChangesSettingsControllerFindContractBaselineQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectChangesSettingsControllerFindContractBaselineQueryKey(projectId, params);
  return queryOptions<ProjectChangesSettingsControllerFindContractBaselineQueryResponse, ResponseErrorConfig<ProjectChangesSettingsControllerFindContractBaseline400 | ProjectChangesSettingsControllerFindContractBaseline401 | ProjectChangesSettingsControllerFindContractBaseline403 | ProjectChangesSettingsControllerFindContractBaseline404>, ProjectChangesSettingsControllerFindContractBaselineQueryResponse, typeof queryKey>({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectChangesSettingsControllerFindContractBaseline(projectId, params, config);
    }
  });
}

/**
 * @summary Get the prime-contract baseline for Changes
 * {@link /api/v1/project-changes-settings/:projectId/contract-baseline}
 */
export function useProjectChangesSettingsControllerFindContractBaseline<TData = ProjectChangesSettingsControllerFindContractBaselineQueryResponse, TQueryData = ProjectChangesSettingsControllerFindContractBaselineQueryResponse, TQueryKey extends QueryKey = ProjectChangesSettingsControllerFindContractBaselineQueryKey>(projectId: ProjectChangesSettingsControllerFindContractBaselinePathParams["projectId"], params?: ProjectChangesSettingsControllerFindContractBaselineQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectChangesSettingsControllerFindContractBaselineQueryResponse, ResponseErrorConfig<ProjectChangesSettingsControllerFindContractBaseline400 | ProjectChangesSettingsControllerFindContractBaseline401 | ProjectChangesSettingsControllerFindContractBaseline403 | ProjectChangesSettingsControllerFindContractBaseline404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectChangesSettingsControllerFindContractBaselineQueryKey(projectId, params);
  const query = useQuery({
    ...projectChangesSettingsControllerFindContractBaselineQueryOptions(projectId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectChangesSettingsControllerFindContractBaseline400 | ProjectChangesSettingsControllerFindContractBaseline401 | ProjectChangesSettingsControllerFindContractBaseline403 | ProjectChangesSettingsControllerFindContractBaseline404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}